export default __webpack_public_path__ + "static/hammond-f500438db71cc834997aef1a447d3761.jpg";